import { Link } from "react-router-dom";

const NotFound = () => (
  <div className="mx-auto max-w-[1600px] px-5 py-40 md:px-10" data-testid="not-found-page">
    <h1 className="font-display text-5xl uppercase leading-[0.98] text-nexa-bone md:text-7xl">
      That page never made it out of the den.
    </h1>
    <p className="mt-6 max-w-lg text-base leading-relaxed text-nexa-bone/60">
      The URL you followed does not exist — but the work does.
    </p>
    <Link to="/" className="link-line mt-8 inline-block font-mono text-xs uppercase tracking-[0.2em] text-nexa-red" data-testid="not-found-home-link">
      Back to the den
    </Link>
  </div>
);

export default NotFound;
